import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { BrandLockup } from "@/components/shell/brand-logo";
import { useAuthStore } from "@/stores/auth-store";

/**
 * Matches the validated prototype: every Auth screen uses the centered
 * logo-only header except tenant-select, which uses a split header (logo
 * left, "Need a different account? Switch account" right — see
 * styles/auth.css `.auth-header--split` in the prototype and
 * pages/auth/tenant-select.html). /login also uses a split header now,
 * per the SSO login screen's Figma reference — logo left, "Don't have an
 * account? Contact your administrator" right. There's no account-contact
 * flow in this repo, so that's static styled text, not a real link/action.
 */
export function AuthHeader() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const goLogin = useAuthStore((s) => s.goLogin);

  if (pathname === "/tenant-select") {
    return (
      <header className="auth-header auth-header--split">
        <Link to="/" aria-label="Alloy home" className="auth-logo">
          <BrandLockup />
        </Link>
        <div className="flex items-center gap-1.5">
          <span className="text-sm text-text">Need a different account?</span>
          <button
            type="button"
            onClick={() => {
              goLogin();
              navigate("/login");
            }}
            className="text-sm font-semibold text-primary outline-none hover:underline focus-visible:ring-2 focus-visible:ring-primary-soft"
          >
            Switch account
          </button>
        </div>
      </header>
    );
  }

  if (pathname === "/login") {
    return (
      <header className="auth-header auth-header--split">
        <Link to="/" aria-label="Alloy home" className="auth-logo">
          <BrandLockup />
        </Link>
        <div className="flex items-center gap-1.5 text-sm">
          <span className="text-text">Don&apos;t have an account?</span>
          <span className="font-semibold text-primary">Contact your administrator</span>
        </div>
      </header>
    );
  }

  return (
    <header className="auth-header">
      <Link to="/" aria-label="Alloy home" className="auth-logo">
        <BrandLockup />
      </Link>
    </header>
  );
}
